import { Component, OnInit } from '@angular/core';
import { MainService } from 'src/app/services/delavci/main.service';
import { SaleService } from 'src/app/services/partner/sale.service';
import * as moment from 'moment';
import { UntypedFormControl } from '@angular/forms';
import { SaleParameters } from 'src/app/models/SaleParameters';
import { SaleOrder } from 'src/app/models/SaleOrder';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { SaleAllParameters } from 'src/app/models/SaleAllParameters';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
export const MY_FORMATS = {
  parse: {
    dateInput: 'DD.MM.YYYY',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'DD.MM.YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'DD.MM.YYYY',
  },
};

@Component({
  selector: 'app-sale-filter',
  templateUrl: './sale-filter.component.html',
  styleUrls: ['./sale-filter.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ]
})
export class SaleFilterComponent implements OnInit {

  public dateFrom;
  public dateTo;
  public chxb_datumZaDatum = false;
  public chxb_samodejniDatum = false;
  public chxb_prikaziDrzave = false;
  public chxb_prikaziPoslovalnice = false;
  public chxb_prikaziProcent = false;
  public chxb_prikaziProcentNaPlan = false;
  public chbx_hitroOsvezevanje = false;
  public chxb_EUR = false;
  public chxb_razprto = false;

  public reportsList: Array<SaleParameters>;
  public typesList: Array<SaleParameters>;
  public countriesList: Array<SaleParameters>;
  public orderList: Array<SaleOrder> = [];
  public sortList: Array<SaleOrder> = [];
  public groupTypeList: Array<SaleParameters>;
  public warehousesList: Array<SaleParameters>;

  public selectedReport: SaleParameters;
  public timeCompare;
  public selectedTypes: Array<SaleParameters>;
  public selectedCountries: Array<SaleParameters>;
  public selectedOrder: SaleOrder;
  public selectedSort: SaleOrder;
  public selectedWarehouses;
  public fetch = 20;
  public selectedGroupTypes: SaleParameters;

  public joinedParameters: SaleAllParameters;
  public toggleDate;
  public isMobile;
  constructor(private mainService: MainService, private saleService: SaleService, private router: Router,
    private deviceService: DeviceDetectorService) { }

  ngOnInit() {
    this.isMobile = this.deviceService.isMobile();
    if(this.saleService.currentSaleParametersValue) {
      this.toggleDate = this.saleService.currentSaleParametersValue.chxb_samodejniDatum;
      this.dateFrom = new UntypedFormControl(moment(this.saleService.currentSaleParametersValue.dateFrom, 'DD.MM.YYYY'));
      this.dateTo = new UntypedFormControl(moment(this.saleService.currentSaleParametersValue.dateTo, 'DD.MM.YYYY'));
      this.timeCompare = this.saleService.currentSaleParametersValue.timeCompare;
      this.selectedReport = this.saleService.currentSaleParametersValue.reportsList;
      this.chxb_EUR = this.saleService.currentSaleParametersValue.chxb_EUR;
      this.chbx_hitroOsvezevanje = this.saleService.currentSaleParametersValue.chbx_hitroOsvezevanje;
      this.chxb_samodejniDatum = this.saleService.currentSaleParametersValue.chxb_samodejniDatum;
      this.chxb_prikaziDrzave = this.saleService.currentSaleParametersValue.chxb_prikaziDrzave;
      this.chxb_prikaziPoslovalnice = this.saleService.currentSaleParametersValue.chxb_prikaziPoslovalnice;
      this.chxb_prikaziProcent = this.saleService.currentSaleParametersValue.chxb_prikaziProcent;
      this.chxb_prikaziProcentNaPlan = this.saleService.currentSaleParametersValue.chxb_prikaziProcentNaPlan;
      this.chxb_razprto = this.saleService.currentSaleParametersValue.chxb_razprto;
      this.dateFrom = new UntypedFormControl(moment(this.saleService.currentSaleParametersValue.dateFrom, 'DD.MM.YYYY'));
      this.dateTo = new UntypedFormControl(moment(this.saleService.currentSaleParametersValue.dateTo, 'DD.MM.YYYY'));

      this.selectedTypes = this.saleService.currentSaleParametersValue.typesList;
      this.selectedWarehouses = this.saleService.currentSaleParametersValue.warehousesList;
      this.selectedCountries = this.saleService.currentSaleParametersValue.countriesList;
      this.selectedOrder = this.saleService.currentSaleParametersValue.orderList;
      this.selectedGroupTypes = this.saleService.currentSaleParametersValue.groupType;
      this.selectedSort = this.saleService.currentSaleParametersValue.sortList;
      this.fetch = this.saleService.currentSaleParametersValue.fetch;
    } else {
      this.dateFrom = new UntypedFormControl(moment().startOf('month'));
      this.dateTo = new UntypedFormControl(moment());
    }

    this.reportsCallWS();
    this.typesCallWS();
    this.countriesCallWS();
    this.typeGroupCallWS();
    this.fillOrderAndSort();
    this.getWorkerWarehouse();
  }

  reportsCallWS() {
    this.saleService.reports(this.mainService.currentUserValue.sessionUser).subscribe( data => {
      this.reportsList = data.data.reports;
    }, error => {
      console.log(error);
    });
  }

  typeGroupCallWS() {
    this.saleService.groupTypes(this.mainService.currentUserValue.sessionUser).subscribe( data => {
      this.groupTypeList = data.data.reports;
    }, error => {
      console.log(error);
    });
  }

  typesCallWS() {
    this.saleService.workerWarehouseTypes(this.mainService.currentUserValue.sessionUser).subscribe( data => {
      this.typesList = data.data.types;
    }, error => {
      console.log(error);
    });
  }

  countriesCallWS() {
    this.saleService.workerCountries(this.mainService.currentUserValue.sessionUser).subscribe( data => {
      this.countriesList = data.data.countries;
    }, error => {
      console.log(error);
    });
  }

  fillOrderAndSort() {
    this.orderList.push(
      {code: 'PART_CODE', title: 'Koda trgovina'},
      {code: 'PART_TITLESMALL', title: 'Naziv trgovine'},
      {code: 'SALEVALUEWT', title: 'Vrednost'},
      {code: 'COMPARE_PERCENT', title: 'Procent'}
    );
    this.sortList.push(
      {code: 'ASC', title: 'Naraščajoče'},
      {code: 'DESC', title: 'Padajoče'}
    );
  }
  onSubmit() {


    this.joinedParameters = {dateFrom: moment(this.dateFrom.value).format("DD.MM.YYYY"),
      dateTo: moment(this.dateTo.value).format("DD.MM.YYYY"), chxb_datumZaDatum: this.chxb_datumZaDatum,
      chxb_samodejniDatum: this.chxb_samodejniDatum, chxb_prikaziDrzave: this.chxb_prikaziDrzave,
      chxb_prikaziPoslovalnice: this.chxb_prikaziPoslovalnice, chxb_prikaziProcent: this.chxb_prikaziProcent,
      chxb_prikaziProcentNaPlan: this.chxb_prikaziProcentNaPlan,
      chbx_hitroOsvezevanje: this.chbx_hitroOsvezevanje, chxb_EUR: this.chxb_EUR,
      chxb_razprto: this.chxb_razprto, timeCompare: this.timeCompare, reportsList: this.selectedReport,
      typesList: this.selectedTypes, warehousesList: this.selectedWarehouses, countriesList: this.selectedCountries, orderList: this.selectedOrder,
      sortList: this.selectedSort, fetch: this.fetch, groupType: this.selectedGroupTypes};
    this.saleService.changeSaleParameters(this.joinedParameters);
    //this.router.navigate(['/prodaja']);
    this.mainService.changeProdajaSettingsBool(false);
  }

  onSamodejniDatum() {
    if (this.chxb_samodejniDatum === false) {
      this.toggleDate = true;
      this.dateFrom = new UntypedFormControl(moment().startOf('month'));
      this.dateTo = new UntypedFormControl(moment());
    } else {
      this.toggleDate = false;
    }
  }

  onBack() {
    this.mainService.changeProdajaSettingsBool(false);
  }

  getWorkerWarehouse() {
    console.log(this.mainService.currentUserValue.sessionUser);
    this.saleService.workerWarehouse(this.mainService.currentUserValue.sessionUser).subscribe(data => {
      this.warehousesList = data.data.warehouses;
      this.warehousesList.push({id: 'vsa', code: 'vsaskladisca', nameSmall: 'Vsa skladišča'});
      console.log(this.warehousesList);
      console.log(data);
    }, error => {
      console.log(error);
    });
  }

}
